/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1ExamExamlangidImportExamItemGridQueryResponse,
  GetApiV1ExamExamlangidImportExamItemGridPathParams,
  GetApiV1ExamExamlangidImportExamItemGridQueryParams,
  GetApiV1ExamExamlangidImportExamItemGrid400,
  GetApiV1ExamExamlangidImportExamItemGrid401,
  GetApiV1ExamExamlangidImportExamItemGrid500,
} from "../../types/examEvaluationController/GetApiV1ExamExamlangidImportExamItemGrid.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1ExamExamlangidImportExamItemGrid } from "../../clients/examEvaluationController/getApiV1ExamExamlangidImportExamItemGrid.ts";

export const getApiV1ExamExamlangidImportExamItemGridQueryKey = (
  examLangId: GetApiV1ExamExamlangidImportExamItemGridPathParams["examLangId"],
  params?: GetApiV1ExamExamlangidImportExamItemGridQueryParams,
) =>
  [
    {
      url: "/api/v1/exam/:examLangId/import-exam-item-grid",
      params: { examLangId: examLangId },
    },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1ExamExamlangidImportExamItemGridQueryKey = ReturnType<
  typeof getApiV1ExamExamlangidImportExamItemGridQueryKey
>;

export function getApiV1ExamExamlangidImportExamItemGridQueryOptions(
  examLangId: GetApiV1ExamExamlangidImportExamItemGridPathParams["examLangId"],
  params?: GetApiV1ExamExamlangidImportExamItemGridQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1ExamExamlangidImportExamItemGridQueryKey(
    examLangId,
    params,
  );
  return queryOptions<
    GetApiV1ExamExamlangidImportExamItemGridQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ExamExamlangidImportExamItemGrid400
      | GetApiV1ExamExamlangidImportExamItemGrid401
      | GetApiV1ExamExamlangidImportExamItemGrid500
    >,
    GetApiV1ExamExamlangidImportExamItemGridQueryResponse,
    typeof queryKey
  >({
    enabled: !!examLangId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1ExamExamlangidImportExamItemGrid(examLangId, params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna a lista paginada de questões da biblioteca disponíveis para importar em uma versão de prova (ExamLang). Filtra pelo tipo da prova: provas de avaliação docente ou de instrutor exibem apenas questões com TeacherEvaluation; provas Challenge exibem apenas tipos fechados (Escolha Simples ou Múltipla). Aceita filtros opcionais de empresa, idioma, autor, disciplina, tipo de componente e intervalo de data de criação. A empresa do usuário logado tem precedência sobre o filtro de empresa. **(Requer Authorization para autenticação)**
 * @summary Listar questões disponíveis para importação (Requer Authorization para autenticação)
 * {@link /api/v1/exam/:examLangId/import-exam-item-grid}
 */
export function useGetApiV1ExamExamlangidImportExamItemGrid<
  TData = GetApiV1ExamExamlangidImportExamItemGridQueryResponse,
  TQueryData = GetApiV1ExamExamlangidImportExamItemGridQueryResponse,
  TQueryKey extends QueryKey = GetApiV1ExamExamlangidImportExamItemGridQueryKey,
>(
  examLangId: GetApiV1ExamExamlangidImportExamItemGridPathParams["examLangId"],
  params?: GetApiV1ExamExamlangidImportExamItemGridQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1ExamExamlangidImportExamItemGridQueryResponse,
        ResponseErrorConfig<
          | GetApiV1ExamExamlangidImportExamItemGrid400
          | GetApiV1ExamExamlangidImportExamItemGrid401
          | GetApiV1ExamExamlangidImportExamItemGrid500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1ExamExamlangidImportExamItemGridQueryKey(examLangId, params);

  const query = useQuery(
    {
      ...getApiV1ExamExamlangidImportExamItemGridQueryOptions(
        examLangId,
        params,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1ExamExamlangidImportExamItemGrid400
      | GetApiV1ExamExamlangidImportExamItemGrid401
      | GetApiV1ExamExamlangidImportExamItemGrid500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
